import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import * as Routes from '@/modules/routes';
import QueryKeys from '@/utils/QueryKeys';
import { toQueryParams } from './reportParams';
import type { AISafetyReportResponse, ReportParams } from './types';

const reportPath = (params: ReportParams) => Routes.admin_ai_safety_reports_path({
  ...toQueryParams(params), format: 'json',
});

const useAISafetyReport = (params: ReportParams) => useQuery({
  queryFn: () => axios.get<AISafetyReportResponse>(reportPath(params)).then(res => res.data),
  queryKey: [QueryKeys.AISafetyReport, params.feature, params.from, params.to, params.subscriberId ?? null],
});

export default useAISafetyReport;
